import * as React from 'react';

import './index.scss';

interface ITextareaProps {
  left: number;
  top: number;
  text: string;
  onChangeText: (text: string) => void;
  onBlur?: () => void;
  onSubmit?: () => void;
  fontSize?: number;
  color?: string;
  fontFamily?: string;
}

const Textarea: React.FC<ITextareaProps> = (props: ITextareaProps) => {
  const textRef = React.useRef<HTMLTextAreaElement | null>(null);
  React.useEffect(() => {
    if (textRef) {
      textRef.current?.focus();
      textRef.current?.select();
    }
  }, []);
  
  const style: React.CSSProperties = {
    left: props.left,
    top: props.top,
  };

  if (props.fontSize) style.fontSize = props.fontSize;
  if (props.color) style.color = props.color; // Note: 'color' sets text color
  if (props.fontFamily) style.fontFamily = props.fontFamily;

  return (
    <textarea
      className="textarea"
      ref={textRef}
      style={style}
      value={props.text}
      onBlur={props.onBlur}
      onKeyDown={(e) => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
          props.onSubmit?.();
          e.preventDefault();
        }
        e.stopPropagation(); // Prevent triggering app-level shortcuts
      }}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
        props.onChangeText(e.target.value);
        if (textRef && textRef.current) {
          textRef.current.style.height = 'auto';
          textRef.current.style.height = textRef.current.scrollHeight + 'px';
        }
      }}
    />
  );
};

export default Textarea;
